import React from 'react';
import styles from './progress-loader.module.scss';

/**
 * Activity line shown while the pipeline runs. Text is backend-authored (AG-UI
 * ACTIVITY_SNAPSHOT) and rendered verbatim; renders nothing when there's no
 * active status. i18n: the text arrives in English and isn't localized yet.
 */
export function ProgressLoader({ status }: { status: string }) {
  if (!status) return null;

  // `role="status"` is a polite live region in its own right, and names the
  // line for assistive tech (and tests) as what it is: the run's status.
  return (
    <p role="status" className={styles.label}>
      <span>{status}</span>
      <span className={styles.dots} aria-hidden="true" />
    </p>
  );
}
